import type { SVGProps } from 'react';
const DawnFlagCV = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-CV_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g clipRule="evenodd" mask="url(#dawn-flag-CV_svg__a)">
      <path fill="#0C49AE" fillRule="evenodd" d="M0 8.533h22V0H0zM0 16h22v-4.267H0z" />
      <path fill="#fff" fillRule="evenodd" d="M0 11.733h22v-3.2H0z" />
      <path fill="#CD232E" fillRule="evenodd" d="M0 10.667h22V9.6H0z" />
      <path
        stroke="#F7D035"
        strokeDasharray="0.67 2"
        strokeLinecap="round"
        strokeWidth={1.333}
        d="M8.381 13.333c1.736 0 3.143-1.432 3.143-3.2 0-1.767-1.407-3.2-3.143-3.2s-3.143 1.433-3.143 3.2 1.407 3.2 3.143 3.2Z"
      />
    </g>
  </svg>
);
export default DawnFlagCV;
